import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=4df3b335&scoped=true&"
import script from "./CampaignSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignSummary.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSummary.vue?vue&type=style&index=0&id=4df3b335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df3b335",
  null
  
)

export default component.exports